//商品
import commodity from '@/views/commodity'
import statistical from '@/views/commodity/statistical'
import commodityDetails from '@/views/commodity/shopDetails'
import marketList from '@/views/commodity/marketList'
//实体卡
import address from '@/views/card/address'
import buyList from '@/views/card/list'
import card from '@/views/card'
import cardOrderDetail from '@/views/card/cardOrderDetail'
import cardstatistical from '@/views/card/statistical'
import statisticalDetail from '@/views/card/statisticalDetail'


import wl from '@/views/card/wl'

export default [{
    path: '/commodity/card',
    name: 'card',
    meta: [{
      name: '下单'
    }],
    component: card
  },
  {
    path: '/commodity/marketList',
    name: 'marketList',
    meta: [{
      name: '营销材料列表'
    }],
    component: marketList
  },
  {
    path: '/commodity/address',
    name: 'address',
    meta: [{
      name: '下单'
    }, {
      name: '选择地址并付款'
    }],
    component: address
  },
  {
    path: '/commodity/buyList',
    name: 'buyList',
    meta: [{
      name: '购买记录'
    }],
    component: buyList
  },
  {
    path: '/commodity/cardOrderDetail',
    name: 'cardOrderDetail',
    meta: [{
      name: '购买记录'
    }, {
      name: '购买详情'
    }],
    component: cardOrderDetail
  },
  {
    path: '/commodity/cardstatistical',
    name: 'cardstatistical',
    meta: [{
      name: '销售统计'
    }],
    component: cardstatistical
  },
  {
    path: '/commodity/statisticalDetail',
    name: 'statisticalDetail',
    meta: [{
      name: '销售统计'
    }, {
      name: '统计详情'
    }],
    component: statisticalDetail
  },
  {
    path: '/commodity/wl',
    name: 'wl',
    meta: [{
      name: '销售统计'
    }, {
      name: '物流'
    }],
    component: wl
  },
  {
    path: '/commodity',
    name: 'commodity',
    meta: [{
      name: '已签约的商品'
    }],
    component: commodity
  },
  {
    path: '/commodity/statistical',
    name: 'statistical',
    meta: [{
      name: '商品销售统计'
    }],
    component: statistical
  },
  {
    path: '/commodity/commodityDetails',
    name: 'commodityDetails',
    meta: [{
        name: '已签约的商品'
      },
      {
        name: '已签约的商品详情'
      },
    ],
    component: commodityDetails
  },
  {
    path: '/commodity/commodityDetails',
    name: 'commodityDetails',
    meta: [{
        name: '已签约的商品'
      },
      {
        name: '已签约的商品详情'
      },
    ],
    component: commodityDetails
  },
  // {
  //   path: '/commodity/history',
  //   name: 'history',
  //   meta: [{
  //       name: '修改保障人'
  //     },
  //     {
  //       name: '修改保障人'
  //     },
  //   ],
  //   component: history
  // }
]



// WEBPACK FOOTER //
// ./src/router/commodity.js